import parse from 'html-react-parser';
const converterTagHtml = (params)=>{
    return(
        <div>
            {parse(String(params))}
        </div>
    )
}
export default converterTagHtml